import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { Download, ShieldCheck, Zap } from 'lucide-react';
const MASTER_SYSTEM_CHECKOUT = 'https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026';
export function MasterFinalCTA() {
  const goToCheckout = () => {
    window.open(MASTER_SYSTEM_CHECKOUT, '_blank', 'noopener,noreferrer');
  };
  return <section className="bg-brand-green px-5 py-20 text-white sm:px-6 md:py-28" data-id="element-378">
      <div className="mx-auto max-w-3xl text-center" data-id="element-379">
        <FadeIn data-id="element-380">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-381">
            Amazon Master System™
          </p>
          <h2 className="font-serif text-4xl font-bold leading-tight tracking-tight sm:text-5xl" data-id="element-382">
            Comienza hoy tu camino para aprender a vender en Amazon.
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-383">
            Accede a un programa organizado para avanzar desde cero con una ruta
            clara y material listo para acompañarte.
          </p>
        </FadeIn>

        <FadeIn delay={0.12} data-id="element-384">
          <div className="mx-auto mt-10 max-w-2xl" data-id="element-385">
            <Button onClick={goToCheckout} aria-label="Comenzar ahora" className="w-full" data-id="element-386">
              COMENZAR AHORA
            </Button>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-3 text-xs font-medium text-white/70 sm:gap-x-6" data-id="element-387">
              <span className="flex items-center gap-1.5" data-id="element-388">
                <Zap className="h-3.5 w-3.5 text-brand-gold" data-id="element-389" />
                Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-390">
                <ShieldCheck className="h-3.5 w-3.5 text-brand-gold" data-id="element-391" />
                Pago único
              </span>
              <span className="flex items-center gap-1.5" data-id="element-392">
                <Download className="h-3.5 w-3.5 text-brand-gold" data-id="element-393" />
                Descarga digital
              </span>
              <span className="flex items-center gap-1.5" data-id="element-394">
                <Zap className="h-3.5 w-3.5 text-brand-gold" data-id="element-395" />
                Acceso de por vida
              </span>
              <span className="flex items-center gap-1.5" data-id="element-396">
                <ShieldCheck className="h-3.5 w-3.5 text-brand-gold" data-id="element-397" />
                Compra 100 % segura
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}